import classNames from 'classnames'
import React, { useEffect, useRef } from 'react'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import styles from '../../organisms/productPageSections/productDetailsAndCare/productDetailsAndCareV2.module.scss'
import { addClassBasedOnScroll } from '../../organisms/productPageSections/productDetailsAndCare/utils'

import ProductDetailsIcon from './product-details-icon'
import { chipsRowDsClass, chipsRowNoFadeDsClass } from './product-details-icon-ds.styles'
import { ProductDetailsIconSectionProps } from './types'

const ProductDetailsIconSection = ({ icons, wrapperClassName }: ProductDetailsIconSectionProps) => {
  const useDs = shouldUseDesignSystem()
  const iconsContainerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const el = iconsContainerRef.current
    if (!el) return
    const noFadeClass = useDs ? chipsRowNoFadeDsClass : (styles.noFade ?? 'noFade')
    const handleScroll = () => {
      addClassBasedOnScroll(el, noFadeClass, 0.9)
    }
    el.addEventListener('scroll', handleScroll)
    return () => {
      el.removeEventListener('scroll', handleScroll)
    }
  }, [useDs])
  if (icons.length === 0) return null
  return (
    <div
      className={classNames(useDs ? chipsRowDsClass : styles.productDetailsAndCareV2__iconsContainer, wrapperClassName)}
      ref={iconsContainerRef}
    >
      {icons.map(icon => (
        <ProductDetailsIcon key={icon.displayTitle} displayTitle={icon.displayTitle} image={icon.image} />
      ))}
    </div>
  )
}

export default ProductDetailsIconSection
